var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownBlogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.64884 10.5477C8.94286 10.5404 9.22387 10.4186 9.43747 10.2058L16.86 2.70349C17.0865 2.47265 17.2169 2.15667 17.2225 1.82481C17.2281 1.49296 17.1085 1.17231 16.8899 0.933129C16.6713 0.693953 16.3716 0.555753 16.0564 0.548856C15.7413 0.541958 15.4363 0.666918 15.2085 0.896326L8.61173 7.56824L2.01495 0.896325C1.78712 0.666916 1.4822 0.541956 1.16703 0.548854C0.851848 0.555751 0.552123 0.693951 0.33355 0.933128C0.114978 1.17231 -0.00461312 1.49296 0.000994455 1.82481C0.00660203 2.15667 0.136948 2.47265 0.363463 2.70349L7.78599 10.2058C7.90091 10.3204 8.03645 10.4097 8.18462 10.4685C8.3328 10.5272 8.49064 10.5541 8.64884 10.5477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownBlogs);
export default __webpack_public_path__ + "static/media/dropdownBlogs.c1e9b2bd4580106f3aebec0ec359e099.svg";
export { ForwardRef as ReactComponent };